module.exports = __webpack_public_path__ + "img/JJ-troubleshoot.271f403c.png";